import styled, { css } from 'styled-components'

export type MetricValueVariant = 'compact' | 'outlined'
export type MetricValueSize = 'default' | 'small'

interface StyledProps {
  $size: MetricValueSize
  $variant: MetricValueVariant
}

export const Container = styled.div<StyledProps & { $containerWidth?: number }>`
  display: flex;
  align-items: center;

  ${({ $containerWidth, $size, $variant, theme }) =>
    $variant === 'outlined'
      ? css`
          gap: 8px;
          box-sizing: border-box;
          min-width: 120px;
          width: ${$containerWidth ? `${$containerWidth}px` : 'auto'};
          padding: 6px;
          border: 2px solid ${theme.colors.grey2};
          border-radius: 6px;
        `
      : css`
          flex: 1;
          gap: ${$size === 'small' ? '8px' : '10px'};
          min-width: 0;
        `}
`

export const Value = styled.span<StyledProps & { $valueWidth?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  ${({ $size, $valueWidth, $variant, theme }) =>
    $variant === 'outlined'
      ? css`
          box-sizing: border-box;
          flex: none;
          min-width: ${$valueWidth ? `${$valueWidth}px` : '50px'};
          width: ${$valueWidth ? `${$valueWidth}px` : 'auto'};
          height: 40px;
          padding: 8px 13px;
          color: ${theme.colors.olive5};
          background: ${theme.colors.trafficLightNeutral};
          font-size: 16px;
          font-weight: 600;
          line-height: 18px;
        `
      : css`
          flex: ${$valueWidth ? 'none' : 1};
          width: ${$valueWidth ? `${$valueWidth}px` : 'auto'};
          padding: ${$size === 'small' ? '0 3px' : '5px'};
          color: ${theme.colors.olive5};
          background: ${theme.colors.grey2};
          font-size: 14px;
          font-weight: 600;
          line-height: 24px;
        `}
`

export const Unit = styled.span<StyledProps>`
  font-size: ${({ $size, $variant }) =>
    $variant === 'compact' && $size === 'small' ? '12px' : '14px'};
  line-height: ${({ $variant }) => ($variant === 'outlined' ? '18px' : '24px')};
  font-weight: ${({ $size, $variant }) => {
    if ($variant === 'outlined') return 500
    return $size === 'small' ? 400 : 600
  }};
  white-space: nowrap;
  color: ${({ $variant, theme }) =>
    $variant === 'outlined' ? theme.colors.olive : theme.colors.new.baseColor[400]};
`
